<div class="admin-app">
    <main class="admin-main">
        <router-outlet></router-outlet>
    </main>

    <footer class="admin-footer">
        <a href="/cart/legal/imprint" target="_blank" rel="noopener noreferrer">
            Impressum
        </a>
    </footer>
</div>